window.addCookieOnCartCreation = () => {
  const fbpCookie = getCookie("_fbp") ? getCookie("_fbp") : "";
  const fbcCookie = getCookie("_fbc") ? getCookie("_fbc") : "";
  const shippingTimeCart = getCookie("shipping_time_cart") ? getCookie("shipping_time_cart") : "";
  const deliveryTimeCart = getCookie("delivery_time_cart") ? getCookie("delivery_time_cart") : "";

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      attributes: {
        fbp: fbpCookie,
        fbc: fbcCookie,
        shipping: shippingTimeCart,
        delivery: deliveryTimeCart,
      }
    })
  }).then(response => response.json())
};

// === UNIFIED DELIVERY RANGE LOGIC (checkout style) ===
function getMaxWeeksFromRange(weeksString) {
  if (!weeksString || typeof weeksString !== "string") return null;
  // Obsługuje "2-3 weeks", "3 weeks", "2 tygodnie", "2-3 tygodnie"
  const match = weeksString.match(/(\d+)(?:\s*-\s*(\d+))?\s*(week|tydzień|tygodni|weeks)?/i);
  if (match) {
    if (match[2]) {
      return parseInt(match[2], 10);
    } else {
      return parseInt(match[1], 10);
    }
  }
  return null;
}

function getDeliveryWeekRangeFromDays(days) {
  if (days >= 1 && days <= 14) return "1-2 weeks";
  if (days >= 15 && days <= 21) return "2-3 weeks";
  if (days >= 22 && days <= 28) return "3-4 weeks";
  if (days >= 29 && days <= 35) return "4-5 weeks";
  if (days >= 36 && days <= 42) return "5-6 weeks";
  if (days >= 43 && days <= 49) return "6-7 weeks";
  return "7-8 weeks";
}

function getDeliveryRangeFromShippingTime(shippingTimeString) {
  // Jeśli to data (YYYY-MM-DD)
  if (/^\d{4}-\d{2}-\d{2}$/.test(shippingTimeString)) {
    const [year, month, day] = shippingTimeString.split('-').map(Number);
    const today = new Date();
    const deliveryDate = new Date(Date.UTC(year, month - 1, day + 2)); // +2 dni jak w Twojej logice
    const daysDiff = Math.ceil((deliveryDate - today) / (1000 * 60 * 60 * 24));
    return getDeliveryWeekRangeFromDays(daysDiff);
  }
  // Jeśli zakres tygodniowy
  const maxWeeks = getMaxWeeksFromRange(shippingTimeString);
  if (maxWeeks) {
    const today = new Date();
    const deliveryDate = new Date(today);
    deliveryDate.setDate(today.getDate() + maxWeeks * 7);
    const daysDiff = Math.ceil((deliveryDate - today) / (1000 * 60 * 60 * 24));
    return getDeliveryWeekRangeFromDays(daysDiff);
  }
  // Fallback: jeśli nie rozpoznano formatu, domyślnie 3-4 tygodnie
  return "3-4 weeks";
}

window.fetchShippingTimeCartProducts = () => {
  if (!document.querySelector('[data-shipping-time="shipping-info-content"]')) return;
  const shippingInfoArray = Array.from(document.querySelectorAll('[data-name="line-item-cart-added"]'))
    .map(element => {
      const productId = element.querySelector('[data-name="line-item-name"]')?.getAttribute('data-product-variant_id') || "";
      const shippingInfo = element.querySelector('[data-shipping-time="shipping-info-content"]')?.textContent.trim() || "";
      return productId && shippingInfo ? { [productId]: shippingInfo } : null;
    })
    .filter(item => item !== null);

  setCookie("shipping_time_cart", JSON.stringify(shippingInfoArray), 6);

  // Also fetch delivery times while we're here
  fetchDeliveryTimeCartProducts();

  addCookieOnCartCreation();

  const dates = Array.from(document.querySelectorAll('[data-name="line-item-cart-added"]'))
    .map(element => element.querySelector('[data-shipping-time="shipping-info-content"]')?.textContent.trim())
    .filter(dateText => dateText)
    .map(dateText => new Date(dateText));

  const latestDate = dates.length ? new Date(Math.max(...dates)) : null;
  const shippingInfoElement = document.querySelector('[data-name="shipping-info-drawer"]');

  if (shippingInfoElement) {
    if (latestDate) {
      const currentDate = new Date();
      const timeDifference = latestDate - currentDate;
      const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
      let shippingInfo = "";
      shippingInfoElement.classList.add("estimated-ship");
      const productQuantities = Array.from(document.querySelectorAll('[data-name="line-item-cart-added"]'))
        .map(item => parseInt(item.querySelector('[data-name="line-item-name"]')?.getAttribute('data-product-variant_stock')) || 0);

      if (daysDifference <= 2 && productQuantities.every(quantity => quantity >= 1)) {
        shippingInfo = "Estimated shipping: 1-2 business days";
        shippingInfoElement.classList.add("ready-to-ship");
      } else {
        // Używamy uniwersalnej funkcji do mapowania na zakresy tygodniowe
        const weekRange = getDeliveryWeekRangeFromDays(daysDifference);
        shippingInfo = `Estimated shipping: ${weekRange}`;
      }
      shippingInfoElement.textContent = shippingInfo;
    }
  }
};

window.fetchDeliveryTimeCartProducts = () => {
  if (!document.querySelector('[data-delivery-time="delivery-info-content"]')) return;

  const deliveryInfoArray = Array.from(document.querySelectorAll('[data-name="line-item-cart-added"]'))
    .map(element => {
      const productId = element.querySelector('[data-name="line-item-name"]')?.getAttribute('data-product-variant_id') || "";
      const deliveryInfo = element.querySelector('[data-delivery-time="delivery-info-content"]')?.textContent.trim() || "";
      return productId && deliveryInfo ? { [productId]: deliveryInfo } : null;
    })
    .filter(item => item !== null);

  setCookie("delivery_time_cart", JSON.stringify(deliveryInfoArray), 6);

  const deliveryDates = Array.from(document.querySelectorAll('[data-name="line-item-cart-added"]'))
    .map(element => {
      const deliveryInfo = element.querySelector('[data-delivery-time="delivery-info-content"]')?.textContent.trim();
      if (deliveryInfo && deliveryInfo !== "") {
        return new Date(deliveryInfo);
      }
      // Fallback: jeśli nie ma deliveryTimeVariant, użyj product shipping time
      const productShippingTime = element.querySelector('[data-name="line-item-name"]')?.getAttribute('data-product-shipping-time');
      if (productShippingTime) {
        const weekRange = getDeliveryRangeFromShippingTime(productShippingTime);
        // Konwertuj week range na datę (np. "2-3 weeks" -> data za 21 dni)
        const maxWeeks = getMaxWeeksFromRange(productShippingTime);
        if (maxWeeks) {
          const today = new Date();
          const deliveryDate = new Date(today);
          deliveryDate.setDate(today.getDate() + maxWeeks * 7);
          return deliveryDate;
        }
      }
      return null;
    })
    .filter(date => date !== null);

  const latestDeliveryDate = deliveryDates.length ? new Date(Math.max(...deliveryDates)) : null;
  const deliveryInfoElement = document.querySelector('[data-name="delivery-info-drawer"]');

  if (deliveryInfoElement) {
    if (latestDeliveryDate) {
      const currentDate = new Date();
      const timeDifference = latestDeliveryDate - currentDate;
      const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
      let deliveryInfo = "";
      deliveryInfoElement.classList.add("estimated-delivery");

      const productQuantities = Array.from(document.querySelectorAll('[data-name="line-item-cart-added"]'))
        .map(item => parseInt(item.querySelector('[data-name="line-item-name"]')?.getAttribute('data-product-variant_stock')) || 0);

      if (productQuantities.every(quantity => quantity >= 1)) {
        deliveryInfo = "Estimated delivery:" + " " + daysDifference + " business days";
        deliveryInfoElement.classList.add("ready-to-ship");
      } else {
        // Używamy uniwersalnej funkcji do mapowania na zakresy tygodniowe
        const weekRange = getDeliveryWeekRangeFromDays(daysDifference);
        deliveryInfo = `Estimated delivery: ${weekRange}`;
      }
      deliveryInfoElement.textContent = deliveryInfo;
    }
  }
};
